import { useContext } from '@wordpress/element';
import ContextTela from '../../pages/DicasOtimizacao/telaContext';
import Button from '.';

export default function ButtonAnalise({ children, onClick = () => { }, disabled = false }) {
  const { desktop } = useContext(ContextTela);

  return (
    <Button onClick={onClick} disabled={disabled} className={desktop ? 'px-4' : 'w-full'}>
      {children}
    </Button>
  );
}
